export default __webpack_public_path__ + "static/media/desktop_i_clock.73dc0dd3.svg";